module.exports = __webpack_public_path__ + "img/lfaf.4ca25c73.jpg";